import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import {
  Avatar,
  Box,
  Card,
  CardContent,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomDrawerFooter from "../../../../components/CustomDrawar/customDrawarFooter";
import CustomDrawerHeader from "../../../../components/CustomDrawar/customDrawarHeader";
import { setTabActive } from "../../../../lib/slices/tabActiveSlice";
import SnackbarAlert from "../../../../components/SnackBar";

const ProfessionalStep = ({
  allTeamMembers,
  selectedServices,
  selectedTeam,
  handleSelectTeam,
}) => {
  const [selectedPro, setSelectedPro] = useState(() => {
    if (selectedTeam && selectedTeam.length > 0) {
      return allTeamMembers.find(
        (member) => member._id === selectedTeam[0].teamMemberID
      );
    }
    return null;
  });
  const dispatch = useDispatch();
  const tabActive = useSelector((state) => state.tabActive.tabs);
  const [snackbarProps, setSnackbarProps] = useState({
    open: false,
    type: "",
    message: "",
  });

  const handleSnackbarVal = (open, type, message) => {
    setSnackbarProps({
      open,
      type,
      message,
    });
  };

  const handleCloseSnackbar = () => {
    handleSnackbarVal(false, "", "");
  };

  const handleNext = () => {
    if (selectedPro) {
      let newArrrr = selectedServices?.map((serviceee) => {
        return {
          serviceID: serviceee?._id,
          teamMemberID: selectedPro?._id,
          selectedFrom: "professional",
          duration: serviceee?.duration,
          teamMemberPro: selectedPro?.image,
          teamMemberJobTitle: selectedPro.jobtitle,
          teamMemberName: selectedPro?.firstname + selectedPro?.lastname,
        };
      });
      handleSelectTeam(newArrrr);
      dispatch(setTabActive(3));
    } else {
      handleSnackbarVal(true, "error", "Please Select a professional first");
    }
  };

  return (
    <Stack
      height={"100%"}
      display={"flex"}
      flexDirection={"column"}
      justifyContent={"space-between"}
    >
      <Stack>
        <CustomDrawerHeader
          title={"Select Professionals"}
          onBack={() => dispatch(setTabActive(0))}
        />
        <Box sx={{ p: 2 }}>
          <Card
            onClick={() => {
              handleSelectTeam([]);
              dispatch(setTabActive(2));
            }}
            sx={{
              textAlign: "center",
              boxShadow: 0,
              border: "1px solid #ddd",
              borderRadius: 2,
              cursor: "pointer",
              mb: 2,
              "&:hover": {
                backgroundColor: "action.hover",
              },
            }}
          >
            <CardContent
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                py: "16px !important",
              }}
            >
              <GroupAddIcon sx={{ fontSize: 20, mb: 1 }} />
              <Typography fontWeight={400} fontSize={14}>
                Select Professional Per Service
              </Typography>
            </CardContent>
          </Card>

          <Grid container spacing={2}>
            {allTeamMembers.map((professional, index) => (
              <Grid item xs={6} key={index}>
                <Card
                  sx={{
                    textAlign: "center",
                    boxShadow: 0,
                    border:
                      professional?._id === selectedPro?._id
                        ? "2px solid #FF5722"
                        : "1px solid #ddd",
                    borderRadius: 2,
                    cursor: "pointer",
                    position: "relative",
                  }}
                  onClick={() => setSelectedPro(professional, index)}
                >
                  {professional?._id === selectedPro?._id ? (
                    <CheckCircleIcon
                      sx={{
                        position: "absolute",
                        top: 8,
                        left: 8,
                        color: "#FF5722",
                      }}
                    />
                  ) : (
                    <RadioButtonUncheckedIcon
                      sx={{
                        position: "absolute",
                        top: 8,
                        left: 8,
                        color: "#757575",
                      }}
                    />
                  )}
                  <CardContent>
                    <Avatar
                      src={professional?.image}
                      sx={{
                        width: 80,
                        height: 80,
                        margin: "10px auto",
                      }}
                    />
                    <Typography variant="body1" sx={{ fontWeight: "medium" }}>
                      {professional.firstname} {professional.lastname}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Stack>

      <CustomDrawerFooter
        activeStep={tabActive}
        btnTitle={"Next"}
        onNext={handleNext}
      />
      <SnackbarAlert
        snackbarProps={snackbarProps}
        handleCloseSnackbar={handleCloseSnackbar}
      />
    </Stack>
  );
};

export default ProfessionalStep;
